const CONFIG = {
  BASE_URL: 'https://backend-umkm-merdeka.up.railway.app',
}

export default CONFIG;
